export { default } from './chart-pie'
